var React = require('react');

function OriginalsChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 1.34151L26.7344 1.1686e-06L14 13.3264L1.26562 5.53222e-08L-5.86394e-08 1.34151L14 16L28 1.34151Z","fill":"currentColor"}));
}

OriginalsChevronDown.defaultProps = {"width":"28","height":"16","viewBox":"0 0 28 16","fill":"none"};

module.exports = OriginalsChevronDown;

OriginalsChevronDown.default = OriginalsChevronDown;
